import React from 'react';
import { PMCConfig } from '@kyruus/types';
import { FormattedMessage } from '@kyruus/intl';
import messages from '../messages';
import {
  AppointmentAsideStickyBox,
  AppointmentAsideContainer,
  ScheduleAppointmentTitle,
  ContactSection
} from './styles';
import { getContactForLocation } from './utils';
import { EmergencyDisclaimer } from '@kyruus/provider-components';
import { Link } from '@biome-design-system/ui/Link';
import { Log, MarketableLocation } from '../../types';
import { LOGGING_EVENTS } from './constants';
import { AggregatedAvailabilityMFE } from './AggregatedAvailabilityMFE';

export type AppointmentAsideProps = {
  config: PMCConfig;
  location: MarketableLocation;
  productName: string;
  log: Log;
};

export const AppointmentAside = ({
  config,
  productName,
  location,
  log
}: AppointmentAsideProps) => {
  const { id: primaryLocationId, name: locationName } = location;

  const onCloseEmergencyDisclaimer = () => {
    log(LOGGING_EVENTS.CLICK_CLOSE_EMERGENCY_WARNING);
  };

  const onClickEmergencyDisclaimer = (
    event: React.SyntheticEvent<HTMLDivElement>
  ) => {
    if (event.target instanceof HTMLAnchorElement && event.target.href)
      log(LOGGING_EVENTS.CLICK_EMERGENCY_WARNING);
  };

  const primaryPhone = getContactForLocation(location);

  return (
    <AppointmentAsideStickyBox>
      <AppointmentAsideContainer>
        <ScheduleAppointmentTitle
          id="LocationAsideAppointmentTitle"
          data-testid="location-appointment-title"
        >
          <FormattedMessage {...messages.AppointmentTitle} />
        </ScheduleAppointmentTitle>
        <EmergencyDisclaimer
          config={config?.direct_book}
          data-testid="emergency-disclaimer"
          onClose={onCloseEmergencyDisclaimer}
          onClick={onClickEmergencyDisclaimer}
          sx={(theme) => ({
            marginBottom: theme.spacing(3)
          })}
        />
        <AggregatedAvailabilityMFE
          productName={productName}
          primaryLocationId={primaryLocationId}
          locationName={locationName}
          phoneNumber={primaryPhone ?? ''}
        />
        {primaryPhone && (
          <ContactSection>
            <FormattedMessage
              {...messages.NeedHelpContact}
              values={{
                phone: <Link href={`tel:${primaryPhone}`}>{primaryPhone}</Link>
              }}
            ></FormattedMessage>
          </ContactSection>
        )}
      </AppointmentAsideContainer>
    </AppointmentAsideStickyBox>
  );
};
